import { flattenWhereClause } from '@modules/queryBuilder/helpers';
import { SourceName } from 'v2/core/entities/fields';
import {
  SourceFilter,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';

const SOURCES_WITH_NAMESPACE: SourceName[] = [
  'FILE_UPLOAD',
  'SNOWFLAKE',
  'SALESFORCE',
];

function getUpdatedSourceFilter(sourceFilter: SourceFilter | undefined) {
  return sourceFilter
    ? {
        sources: sourceFilter.sources.map((sourceNameWithNamespace) => {
          const source = SOURCES_WITH_NAMESPACE.find((source) =>
            sourceNameWithNamespace.name.includes(source),
          );
          if (
            source &&
            !sourceNameWithNamespace.namespace &&
            sourceNameWithNamespace.name.startsWith(`${source}-`)
          ) {
            return {
              namespace: sourceNameWithNamespace.name.replace(`${source}-`, ''),
              name: source,
            };
          }
          return sourceNameWithNamespace;
        }),
      }
    : undefined;
}

export function getFixedWhereClause(whereClause: WhereClause): WhereClause {
  const updatedWhereClause = flattenWhereClause(whereClause);

  if (updatedWhereClause.filter?.sourceFilter) {
    return {
      ...updatedWhereClause,
      filter: {
        type: updatedWhereClause.filter.type,
        sourceFilter: getUpdatedSourceFilter(
          updatedWhereClause.filter.sourceFilter,
        ),
      },
    };
  }

  if (updatedWhereClause.op) {
    return {
      ...updatedWhereClause,
      op: {
        ...updatedWhereClause.op,
        params: updatedWhereClause.op.params.map((param) => {
          return getFixedWhereClause(param);
        }),
      },
    };
  }

  return updatedWhereClause;
}
